import { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Spin, message } from "antd";
import {
  useCasinoTableQuery,
  useCasinoOddsQuery,
} from "../../../store/service/clientBetService";
import "./Client.scss";

const pickOddsRows = (odds) => {
  if (!odds) return [];
  const sessions = odds?.result?.session;
  if (Array.isArray(sessions) && sessions.length) {
    return sessions.map((s) => ({
      nation: s.session_name || s.sessionName || "Session",
      b1: s.runsYes ?? s.oddsYes,
      l1: s.runsNo ?? s.oddsNo,
      bs1: s.max,
    }));
  }

  // tresting cache shape: { data: { data: { t1, t2 } } }
  const trestingT2 = odds?.data?.data?.t2 || odds?.data?.t2;
  if (Array.isArray(trestingT2) && trestingT2.length) {
    return trestingT2.map((t2) => ({
      nat: t2.nat ?? t2.nation ?? t2.runnerName,
      nation: t2.nat ?? t2.nation ?? t2.runnerName,
      sid: t2.sid,
      b1: t2.b1 ?? t2.rate ?? t2.back ?? t2.odds,
      l1: t2.l1 ?? t2.lay,
      bs1: t2.max ?? t2.bs1,
    }));
  }

  // betfair_api/casino/data/meta-* response (t1/t2)
  if (Array.isArray(odds?.t2) && odds.t2.length) {
    return odds.t2.map((t2) => ({
      nat: t2.nat ?? t2.nation ?? t2.runnerName,
      nation: t2.nat ?? t2.nation ?? t2.runnerName,
      sid: t2.sid,
      b1: t2.b1 ?? t2.rate ?? t2.back ?? t2.odds,
      l1: t2.l1 ?? t2.lay,
      bs1: t2.max ?? t2.bs1,
    }));
  }
  const raw =
    odds?.data ||
    odds?.result ||
    odds?.market ||
    odds?.sub ||
    odds?.odds ||
    odds;
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw?.sub)) return raw.sub;
  if (Array.isArray(odds?.sub)) return odds.sub;
  return [];
};

const ClientCasino = () => {
  const { eventId } = useParams();
  const nav = useNavigate();
  const [showVideo, setShowVideo] = useState(true);

  const { data, isLoading } = useCasinoTableQuery(eventId, {
    skip: !eventId,
    pollingInterval: 8000,
  });

  const table = data?.data?.table;
  const cacheURL = table?.cacheURL || table?.cacheUrl;
  const shortName = table?.shortName;

  const { data: oddsData, isFetching } = useCasinoOddsQuery(
    { eventId, cacheURL, shortName },
    {
      skip: !eventId && !cacheURL && !shortName,
      pollingInterval: 2000,
    }
  );

  const rows = useMemo(
    () => pickOddsRows(oddsData?.data || data?.data?.odds),
    [oddsData, data]
  );

  const videoUrl = table?.videoUrl1 || table?.videoUrl2 || table?.videoUrl;

  if (isLoading && !table) {
    return (
      <div className="play-loading">
        <Spin size="large" tip="Loading casino…" />
      </div>
    );
  }

  if (!table && !isLoading) {
    return (
      <div className="lotus-empty" style={{ margin: 16 }}>
        Casino table not found
        <br />
        <small style={{ opacity: 0.7 }}>
          Sirf VIVO Exchange pe live tables (3030 Teen20, 3035 Dragon…) full chalenge. Token
          expire ho to backend .env me naya token lagao.
        </small>
        <br />
        <button type="button" className="play-back-link" onClick={() => nav("/play")}>
          ← Back
        </button>
      </div>
    );
  }

  return (
    <div className="play-match-page vivo-casino-page">
      <div className="play-top-bar">
        <button type="button" className="play-back-link" onClick={() => nav("/play")}>
          ← Back
        </button>
        <div className="play-match-title">{table.name || "Casino"}</div>
        {table.betStatus ? <span className="play-live-pill">OPEN</span> : null}
      </div>

      <div className="vivo-casino-meta">
        Stake {table.minStake ?? 100} – {table.maxStake ?? 10000}
        {isFetching ? " · updating…" : ""}
      </div>

      {videoUrl ? (
        <div className="vivo-casino-video">
          <button type="button" className="vivo-score-toggle" onClick={() => setShowVideo((v) => !v)}>
            {showVideo ? "Hide video" : "Show video"}
          </button>
          {showVideo ? (
            <iframe title="Casino live" src={videoUrl} allow="autoplay; fullscreen" allowFullScreen />
          ) : null}
        </div>
      ) : null}

      <div className="play-section-head fancy">Markets</div>
      <div className="vivo-casino-odds">
        {rows.length === 0 ? (
          <div className="lotus-empty">Odds loading / suspended</div>
        ) : (
          rows.slice(0, 40).map((row, i) => {
            const name =
              row.nat ||
              row.nation ||
              row.runnerName ||
              row.marketname ||
              row.sid ||
              row.selectionName ||
              `Market ${i + 1}`;
            const b1 = row.b1 ?? row.back ?? row.rate ?? row.odds ?? "—";
            const l1 = row.l1 ?? row.lay ?? "—";
            return (
              <button
                key={`${name}-${i}`}
                type="button"
                className="vivo-casino-odd-row"
                onClick={() =>
                  message.info("Casino stake settling via diamond feed — sports bet flow use Cricket match")
                }>
                <span>{name}</span>
                <em className="lagai">{b1}</em>
                <em className="khai">{l1}</em>
              </button>
            );
          })
        )}
      </div>
    </div>
  );
};

export default ClientCasino;
